import {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import axios from 'axios';
import {Loading} from "../../../components/common/Loading";
import {defaultAlert} from "../../../utils/alert";

export function PaymentCallback() {
    const PAYMENT_URL = process.env.REACT_APP_PG_PAYMENT_API_URL;
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);


    useEffect(() => {
        const checkPayment = async () => {
            // sessionStorage에서 tid 가져오기
            const tid = sessionStorage.getItem('tid');


            if (!tid) {
                alert('결제 정보를 찾을 수 없습니다.');
                navigate('/wallet/charge');
                return;
            }

            try {
                const payToken = sessionStorage.getItem('payToken');

                if (!payToken) {
                    alert('인증 정보가 없습니다. 다시 로그인해주세요.');
                    navigate('/login');
                    return;
                }

                const url = `${PAYMENT_URL}/api/payment/status/${tid}`;
                let success = false;
                for (let i = 0; i < 5; i++) {
                    const response = await axios.get(url, {
                        headers: {
                            'Authorization': `Bearer ${payToken}`
                        }
                    });
                    if (response.data.success) {
                        success = true;
                        setIsLoading(false);
                        defaultAlert("결제 완료");

                        sessionStorage.removeItem('tid');
                        sessionStorage.removeItem('paymentInProgress');

                        const jobPostingCode = sessionStorage.getItem('jobPostingCode');
                        if (jobPostingCode) {
                            sessionStorage.removeItem('jobPostingCode');
                            navigate(`/job/${jobPostingCode}`, { replace: true });
                        } else {
                            navigate('/wallet/charge', { replace: true });
                        }
                        break;
                    }
                }
                if (!success) {
                    // 5회 폴링 모두 실패
                    sessionStorage.removeItem('tid');
                    sessionStorage.removeItem('paymentInProgress');
                    alert('결제 결과를 확인할 수 없습니다. 고객센터에 문의하세요.');
                    navigate('/wallet/charge');
                }
            } catch (error) {
                console.error('결제 확인 오류:', error);
                alert('결제 결과를 확인할 수 없습니다.');
                navigate('/wallet/charge');
            } finally {
                setIsLoading(false);
            }
        };

        checkPayment();
    }, [navigate]);





    return (
        <Loading
            loading={isLoading}
            onClose={() => {
                setIsLoading(false);
                navigate('/wallet/charge');
            }}
        />
    );
}